const COUNTERPARTY_PAGINATION_DEFAULT_LIMIT = 5;
const PAGINATION_DEFAULT_LIMIT = 15;
const PAGINATION_DEFAULT_OFFSET = 0;
const PAGINATION_LIMIT_PAYMENTS = 1000;
const PAGINATION_LIMIT_AUTHORIZATIONS = 1000;
const PAGINATION_LIMIT_CHECKDEPOSIT = 1000;
const MAXIMUM_PAGINATION_LIMIT = 1000;

module.exports = {
  COUNTERPARTY_PAGINATION_DEFAULT_LIMIT,
  PAGINATION_DEFAULT_LIMIT,
  PAGINATION_DEFAULT_OFFSET,
  PAGINATION_LIMIT_PAYMENTS,
  PAGINATION_LIMIT_AUTHORIZATIONS,
  PAGINATION_LIMIT_CHECKDEPOSIT,
  MAXIMUM_PAGINATION_LIMIT
};
